import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const FeedBack = Loadable(lazy(() => import("./FeedBack.jsx")));
const AddFeedback = Loadable(lazy(() => import("./AddFeedback.jsx")));
const ViewFeedback = Loadable(lazy(() => import("./ViewFeedback.jsx")));

const feedBackRoutes = [
    { path: "/feedback", element: <FeedBack/> },
    { path: "/feedback/add", element: <AddFeedback/> },
    { path: "/feedback/view", element: <ViewFeedback/> },
];

export default feedBackRoutes;